import type { ConstValues } from './helpers.ts';

export const PACING_MODE = {
  ASAP: 'asap',
  EVENLY: 'evenly',
} as const;

export type PacingMode = ConstValues<typeof PACING_MODE>;

export const BUDGET_TYPE = {
  IMPRESSIONS: 'impressions',
  SPEND: 'spend',
} as const;

export type BudgetType = ConstValues<typeof BUDGET_TYPE>;

export const BUDGET_MODE = {
  CADENCE: 'cadence',
  CAMPAIGN_FLIGHT_TIME: 'campaign_flight_time',
} as const;

export type BudgetMode = ConstValues<typeof BUDGET_MODE>;

export const MONETIZING_REGION = {
  ASIA: 'ASIA',
  EU: 'EU',
  US: 'US',
} as const;

export type MonetizingRegion = ConstValues<typeof MONETIZING_REGION>;

export const MONETIZING_FIELDS = {
  ACCOUNT_UID: 'account_uid',
  BUDGET: 'budget',
  BUDGET_MODE: 'budget_mode',
  BUDGET_TYPE: 'budget_type',
  CADENCE_TYPE: 'type',
  FLIGHT_END: 'flight_end',
  FLIGHT_START: 'flight_start',
  ID: 'id',
  PACING_MODE: 'pacing_mode',
  REGION: 'region',
  UID: 'uid',
} as const;

export type MonetizingFields = ConstValues<typeof MONETIZING_FIELDS>;

export const CADENCE_TYPE = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
} as const;

export type CadenceType = ConstValues<typeof CADENCE_TYPE>;

type CampaignMode = {
  [MONETIZING_FIELDS.BUDGET]: number;
};

export type Cadence = {
  [MONETIZING_FIELDS.BUDGET]?: null;
  cadences: [
    {
      [MONETIZING_FIELDS.CADENCE_TYPE]: CadenceType;
      [MONETIZING_FIELDS.BUDGET]: number;
    },
  ];
};

export type BudgetingMode = CampaignMode | Cadence;

export type MonetizingApi = {
  [MONETIZING_FIELDS.ID]: string;
  [MONETIZING_FIELDS.UID]: string;
  [MONETIZING_FIELDS.ACCOUNT_UID]: string;
  [MONETIZING_FIELDS.PACING_MODE]: PacingMode;
  [MONETIZING_FIELDS.FLIGHT_START]: string;
  [MONETIZING_FIELDS.FLIGHT_END]?: string;
  [MONETIZING_FIELDS.REGION]: MonetizingRegion;
  [MONETIZING_FIELDS.BUDGET_TYPE]: BudgetType;
} & BudgetingMode;
